import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AvailableSectionListResponse } from '~client/model/available-section-list-response';
import { CheckoutResponse } from '~client/model/checkout-response';
import { CreatePromoterOfferGroupCheckoutRequest } from '~client/model/create-promoter-offer-group-checkout-request';
import { DateFilterType } from '~client/model/date-filter-type';
import { PromoterAssignRequest } from '~client/model/promoter-assign-request';
import { PromoterAssignResponse } from '~client/model/promoter-assign-response';
import { PromoterAvailableTokenAssignmentGroupListResponse } from '~client/model/promoter-available-token-assignment-group-list-response';
import { PromoterEventListResponse } from '~client/model/promoter-event-list-response';
import { PromoterEventOverviewResponse } from '~client/model/promoter-event-overview-response';
import { PromoterEventTransactionDetailResponse } from '~client/model/promoter-event-transaction-detail-response';
import { PromoterEventTransactionResponse } from '~client/model/promoter-event-transaction-response';
import { PromoterInventoryRequest } from '~client/model/promoter-inventory-request';
import { ResponseEntity } from '~client/model/response-entity';

/* User APIs pertaining to promoters */
export class PromoterController extends BaseController {
  /* Returns the list of events the current user is promoting. */
  public getEventList(dateFilterType: DateFilterType): Promise<PromoterEventListResponse> {
    return this.get('/promoter/eventList', { dateFilterType });
  }
  /*
  @deprecated
  Returns the list of events the current user is promoting.
   */
  public getEventList$(dateFilterType: DateFilterType): Observable<PromoterEventListResponse> {
    return this.get$('/promoter/eventList', { dateFilterType });
  }

  /* Validates that the assignment string is valid before the user can accept promoter inventory. */
  public validateAssignment$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/promoter/public/validate', { assignmentString });
  }

  /* Confirms tokens from the client to the current promoter. */
  public confirmTokens$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/promoter/confirm', { assignmentString });
  }

  /* Returns promoter overview information for a particular event. */
  public getEventOverview$(eventId: number): Observable<PromoterEventOverviewResponse> {
    return this.get$(`/promoter/eventOverview`, { eventId });
  }

  /*
   * Returns detailed promoter information for a particular event, specifically the specific
   * inventory they can still sell.
   */
  public getEventDetails$(
    eventId: string,
  ): Observable<PromoterAvailableTokenAssignmentGroupListResponse> {
    return this.get$(`/promoter/eventDetails`, { eventId });
  }

  /* Returns the available sections for this promoter to assign from. */
  public getAvailableSections$(eventId: string): Observable<AvailableSectionListResponse> {
    return this.get$(`/promoter/section`, { eventId });
  }

  /**
   * Retrieves list of inventory of an event available for a promoter
   * @param request
   */
  public getInventory$(
    request: PromoterInventoryRequest,
  ): Observable<AvailableSectionListResponse> {
    return this.get$(`/promoter/inventory`, request);
  }

  /**
   * Checkout for promoter to user
   */
  public checkout$(request: CreatePromoterOfferGroupCheckoutRequest): Observable<CheckoutResponse> {
    return this.post$(`/promoter/checkout`, request);
  }

  /**
   * Returns promoter's pending and completed transactions for a particular event.
   * @param eventId
   */
  public getEventTransactionList$(eventId: number): Observable<PromoterEventTransactionResponse> {
    return this.get$('/promoter/eventTransactionList', { eventId });
  }

  /**
   * Creates offer group for user to purchase inventory item from promoter
   */
  public assign(request: PromoterAssignRequest): Promise<PromoterAssignResponse> {
    return this.post(`/promoter/assign`, request);
  }

  /*
   * Returns details (buyer's info, price, fees etc.) for a particular details.
   */
  public getTransactionDetail$(
    offerGroupId: number,
  ): Observable<PromoterEventTransactionDetailResponse> {
    return this.get$('/promoter/transactionDetail', { offerGroupId });
  }

  /*
   * Cancels the token assignment for a user.
   */
  public revoke$(offerGroupId: number): Observable<ResponseEntity> {
    return this.del$(`/promoter/revoke`, { offerGroupId });
  }

  /*
   * Edits the buyer's email for a promoter to user transaction.
   */
  public edit$(emailAddress: string, offerGroupId: number): Observable<ResponseEntity> {
    return this.put$(`/promoter/edit?emailAddress=${emailAddress}&offerGroupId=${offerGroupId}`);
  }

  /*
   * Resend invitation email from promoter to user.
   */
  public resend$(offerGroupId: number): Observable<ResponseEntity> {
    return this.put$(`/promoter/resend?offerGroupId=${offerGroupId}`);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/promoter-controller.ts